import { Helmet } from 'react-helmet';
import { Card } from '~/components';
import { generateNameFormatted } from '~/helpers/titleHelper';
import { EditDmtInfo } from './DmtEdit';
import { EditDmtSelectClient } from './EditDmtSelectClient';
import { DevLayout } from '../DEVs/DevLayout';
import { t } from 'i18next';
import { DeviceDisassociate } from '../DEVs/DeviceDisassociate';
import { useState } from 'react';
import { getUserProfile } from '~/helpers/userProfile';

export function DmtEditRedirect({
  devInfo, isLoading, devId, renderDevInfo,
}) {
  const [profile] = useState(getUserProfile);
  const isAllowedToDisassociate = profile.permissions.isAdminSistema || profile.permissions.MANAGE_ALL_CLIENTS_AND_DACS || profile.permissions.isInstaller;
  return (
    <>
      {
        (isAllowedToDisassociate && devInfo?.UNIT_ID) && (
          <DeviceDisassociate devId={devId} render={renderDevInfo} devInfo={devInfo} />
        )
      }
      <Helmet>
        <title>{generateNameFormatted(devId, t('editar'))}</title>
      </Helmet>
      <DevLayout devInfo={devInfo} margin="15px" />
      <div style={{ marginTop: '2rem' }} />
      {((!isLoading) && devInfo && devInfo.CLIENT_ID) && (
        <Card>
          <EditDmtInfo dmtInfo={devInfo} />
        </Card>
      )}
      {((!isLoading) && devInfo && !devInfo.CLIENT_ID) && <EditDmtSelectClient dmtInfo={devInfo} renderDevInfo={renderDevInfo} />}
    </>
  );
}
